import script from "./Board.vue?vue&type=script&setup=true&lang=js"
export * from "./Board.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"Board.vue"]])

export default __exports__